import { render, staticRenderFns } from "./GlLogoBizoope.vue?vue&type=template&id=c5b99e70&"
import script from "./GlLogoBizoope.vue?vue&type=script&lang=js&"
export * from "./GlLogoBizoope.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports